import { useCallback, useEffect, useState } from "react";
import { http } from "@/lib/api";
import { useAutoRefresh } from "@/hooks/useAutoRefresh";

// Lote 162 — a bolinha do menu "Compartilhamentos": comentários novos e propostas aguardando decisão (enviados + recebidos).
// Silencioso se a chamada falhar. As telas avisam (avisarNovidades) quando algo muda, para a bolinha acompanhar na hora.
export const EVENTO_NOVIDADES = "colab-novidades";
export const avisarNovidades = () => { try { window.dispatchEvent(new Event(EVENTO_NOVIDADES)); } catch { /* sem window */ } };

export function useColabNovidades() {
  const [n, setN] = useState(0);
  const load = useCallback(async () => {
    try { const r = await http.get("/colab/novidades"); setN((Number(r.data?.enviados) || 0) + (Number(r.data?.recebidos) || 0)); } catch { /* silencioso */ }
  }, []);
  useEffect(() => { load(); window.addEventListener(EVENTO_NOVIDADES, load); return () => window.removeEventListener(EVENTO_NOVIDADES, load); }, [load]);
  useAutoRefresh(load, { intervalMs: 2 * 60 * 1000 });
  return n;
}
